import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogModal : {isOpen: false, activeObject:null},
  aboutModal : {isOpen: false, activeObject:null},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    /* Modal */
    openModal: (state, action) => {
      state.dialogModal = {isOpen : true, activeObject : action.payload};
    },
    closeModal: (state, action) => {
      state.dialogModal = {isOpen : false, activeObject :null, isReadOnly : null};
    },
    /* About Modal */
    openModalAbout: (state, action) => {
      state.aboutModal = {isOpen : true};
      //body element overflow: hidden;
      document.body.style.overflow = "hidden";
    },
    closeModalAbout: (state, action) => {
      state.aboutModal = {isOpen : false};
      //body element overflow: auto;
      document.body.style.overflow = "auto";
    },
  },
});

export const {  openModal, closeModal, 
                openModalAbout, closeModalAbout, 
              } = modalSlice.actions;

export default modalSlice.reducer;
